import React, {
  useState, useEffect
} from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { Table, Tag, Space } from 'antd';
import { Modal } from 'antd';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import { Config } from '../../config/config';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { doGetVendorList, isEdit, addVendor, getloadVendorSupply,getSelectedVendorList,getSelectedVendor } from '../Vendor/actions/vendorService'
import { useDispatch, useSelector } from "react-redux";
import VendorEdit from './VendorEdit';
import VendorAdd from './VendorAdd';
import Cookie from "js-cookie";
import { useNavigate } from 'react-router-dom';
import LZString from 'lz-string';


const { Option } = Select;

const Vendors = () => {
  const vendorList = useSelector(state => state?.vendorList.VendorDetails);
  const vendorDetail = useSelector(state =>state?.vendorList?.VendorSelectedDetail)
  const status = useSelector(state => state?.vendorList);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData);
  let userID = user["userId"]
  const config = JSON.parse(Config);
  const apiInterface = config['api1']
  const title = "Vendor/Company ";
  const [recordDetails, setRecordDetails] = useState('')
  const [searchedItem, setSearchedItem] = useState({
    zone_id: [],
    state_id: [],
    type_of_service_ids: [],
    id: null,
    store_id : null
  })
  const [docModalvisible, setDocModalvisible] = useState(false)
  const [mapModalVisible, setMapModalVisible] = useState(false)
  const TableColumns = [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      onCell: (_, index) => ({
        colSpan: 1,
      }),
      render: (text, record) => (
        <Space size="middle">
          <div className="table-icons">
            <i className="fa fa-pencil blue" onClick={() => _doNavToEditVendor(record)} aria-hidden="true"></i>
            {/* <i className="fa fa-cogs orange" onClick={()=>(_doOpenVendorModal(record))} aria-hidden="true"></i> */}
            {/* <i class="fa fa-cogs orange" onClick={_doOpenVendorContract} aria-hidden="true"></i> */}
          </div>
        </Space>
      ),
    },
    {
      title: "Vendor Name",
      width:200,
      dataIndex: "vendor_name",
      key: "vendor_name"
    },
    // {
    //   title: "Vendor Code",
    //   dataIndex: "vendor_code",
    //   key: "vendor_code"
    // },
    {
      title: "Mobile Number",
      width:100,
      dataIndex: "mobile_number1",
      key: "mobile_number1"
    },
    {
      title: "Email Id",
      width:220,
      dataIndex: "email_address1",
      key: "email_address1"
    },
    // {
    //   title: "Store",
    //   dataIndex: "Store",
    //   key: "Store"
    // },
    {
      title: "Type of services",
      dataIndex: "type_of_service_names",
      key: "service_field_type"
    },
    {
      title: "Created By",
      width:120,
      dataIndex: "createdby",
      key: "createdby"
    },
    {
      title: "Contract Document",
      dataIndex: "ContractDocument",
      key: "ContractDocument",
      render: (text, record) => (
        <Space size="middle">
          <div className="table-file-icon">
            <span onClick={()=>_doOpenDocModal(record)}>
              <i className="fa fa-file-text" aria-hidden="true"></i>
            </span>
          </div>
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "vendorStatus",
      key: "Status",
    }
  ]
  const [tableData, setTableData] = useState([]);
  const filterParams = ["zone_id", "state_id", "type_of_service_ids", "id", "store_id"];
  const _doNavToAddVendor = () => {
    dispatch(addVendor(true))
    setSearchedItem({
      zone_id: [],
    state_id: [],
    type_of_service_ids: [],
    id: null,
    store_id : null
    })
    setTableData(vendorList?.VendorList)
  }
  // const _doNavToEditVendor = (record) => {
  //   dispatch(getloadVendorSupply(record.id, record))
  //   // dispatch(isEdit(true));
  //   // console.log(getSelectedVendorList(record));
  //   // this.props.isEdit(true)

  //   // this.props.navigate("/VendorEdit"); 
  //   navigate("/VendorEdit")
  // }
  const _doNavToEditVendor = async (record) => {
    await dispatch(getloadVendorSupply(record.id, record));
    navigate("/VendorEdit");
};

 
  const _doOpenVendorContract = () => {
    navigate("/VendorContract");
  }
  const _doOpenDocModal = (record) => {
    setDocModalvisible(true)
    dispatch(getSelectedVendor(record.id, record))
  }

  const _doOpenVendorModal = (record) => {
    dispatch(getSelectedVendor(record.id, record))
    setMapModalVisible(true)
  }

  const _doNavToMapVendor = () => {
    navigate("/VendorContractMapping");
  }

  const _doCloseDocModal = () => {
    setDocModalvisible(false)
  }
  const _doCloseMapModal = () => {
    setMapModalVisible(false)
  }
  useEffect(() => {
    if(searchedItem.zone_id.length!=0 || searchedItem.state_id.length !=0 ||searchedItem.type_of_service_ids.length!=0 || searchedItem.id || searchedItem.store_id){
      handleSearch();
    }else{
      setTableData(vendorList?.VendorList)
    }
  }, [vendorList])
  const handleDownload = (ele) =>{
    // window.location.href = `${apiInterface}/downloadimages?Image_id=${ele.contract_file_name}`
    window.location.href = `${apiInterface}/downloadfiles?Image_id=${ele.contract_file_name}&token_id=${Cookie.get('token')}`
  }
  const handleSearch = () => {
  if(searchedItem.state_id.length ==0 && searchedItem.type_of_service_ids.length==0 && searchedItem.zone_id.length==0 && !searchedItem.id && !searchedItem.store_id ){
    setTableData(vendorList?.VendorList)
  }
  else {
    let result =  filterRecursively(filterParams[0], 0);
    bfirstRecursionCompleted = false;
    setTableData(result);
  }
}
let filteredResult = [];
let bfirstRecursionCompleted = false;
let filterStatus = Array(5).fill(0);
const filterRecursively = (filterParam, index) =>{
if(index == filterParams.length)
    return filteredResult;
    if(searchedItem[filterParam] != null || ( Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length)){
    for (let j = 0; j < vendorList?.VendorList.length; j++) {
        if(bfirstRecursionCompleted && filteredResult.length){
        filteredResult.map((ele, i)=> {
            if(((!Array.isArray(searchedItem[filterParam]) && !String(ele[filterParam]).includes(String(searchedItem[filterParam]))) || (Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length && !ele[filterParam].split(',').some(item => String(searchedItem[filterParam]).includes(item))))){
            //remove if searched item is not present for that particular parameter in already filtered Array.
            filteredResult.splice(i, 1);
            }
        })
        }
        else if(!bfirstRecursionCompleted && ((!Array.isArray(searchedItem[filterParam]) && String(vendorList?.VendorList[j][filterParam]).includes(String(searchedItem[filterParam]))) || (Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length && vendorList?.VendorList[j][filterParam].split(',').some(item =>   String(searchedItem[filterParam]).includes(item))))){
        filterStatus[index] = 1;
        filteredResult.push(vendorList?.VendorList[j]);
        }
    }
      }
if(!bfirstRecursionCompleted || filteredResult.length !=0){
    if(filterStatus[index]) bfirstRecursionCompleted = true; //first iteration after filteredResult is filled 
    return filterRecursively(filterParams[index+1], index+1)
  }
}
  useEffect(() => {
    dispatch(doGetVendorList())
  }, [])
  return (
    <>
      {status?.isVendorList ? <div>
        {/* {status?.modalOpen ? (
          <MessageBox
            message={status.message}
            signout={false}
          // onClose={handleClose}
          />
        ) : null} */}
        <Header title={title} />
        <Menu />
        <Modal
          open={docModalvisible} title="Contract Documents"
          footer={[
            <button type='button' onClick={_doCloseDocModal} className='btn muted-button  deca-btn-orange'>Close</button>
          ]}
          className="docmodal"
        >
          <table className="m-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th style={{width:200}}>Contract Name</th>
                <th>Asset List</th>
                <th style={{width:120}}>Contract Start Date</th>
                <th style={{width:120}}>Contract End Date</th>
                <th>Document</th>
              </tr>
            </thead>
            <tbody>
              {/* <tr>
                <td>1</td>
                <td>
                  <span>Contract1.pdf</span>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <span>Contract2.pdf</span>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <span>Document.pdf</span>
                </td>
              </tr> */}
              {
                vendorDetail?.documentData?.map((ele,index)=>(
                  <tr key={index}>
                    <td>{index+1}</td>
                    <td>{ele.contract_name}</td>
                    <td>{ele.asset_name}</td>
                    <td>{ele.contract_start_date}</td>
                    <td>{ele.contract_end_date}</td>
                    <td style={{cursor:'pointer'}} onClick={()=>handleDownload(ele)}><i className="fa fa-download"></i></td>
                    {/* <td>{ele.vendor_contract_map_id}</td> */}
                  </tr>
                ))
              }
            </tbody>
          </table>
        </Modal>
        <Modal
          open={mapModalVisible} title="Vendor Contract" width={1000}
          footer={[
            <button type='button' onClick={_doCloseMapModal} className='btn muted-button  deca-btn-orange'>Close</button>
          ]}
        >
          <div className="modal__btn">
            <button type='button' onClick={_doNavToMapVendor} className='btn muted-button  deca-btn-yellow'>Contract Mapping</button>
          </div>
          <table className="m-table">
            <thead>
              <tr>
                <th>Main category name</th>
                <th>Sub category name</th>
                <th>Asset name</th>
                <th>Contract start date</th>
                <th>Contract end date</th>
              </tr>
            </thead>
            <tbody>
                {
                  vendorDetail?.supplyData?.map((ele,index)=>(
                    <tr key={index}>
                      <td>{ele.main_category_name}</td>
                      <td>{ele.sub_category_name}</td>
                      <td>{ele.asset_name}</td>
                      <td>{ele.contract_start_date}</td>
                      <td>{ele.contract_end_date}</td>
                    </tr>
                  ))
                }
              
            </tbody>
          </table>
        </Modal>
        <div className='content-wrapper'>
          {status?.loading ? (
            <Spinner />
          ) : (
            <div>
              <div className="m-btn-block">
                <div className="m-btn-block__container">
                  <div className="m-btn-block__icon">
                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                  </div>
                  <div className="m-btn-block__btns">
                    <button type='submit' onClick={_doNavToAddVendor} className='btn btn-secondary deca-btn-yellow'>Create New Vendor</button>
                  </div>
                </div>
              </div>
              <div className='content'>
                <div className="m-panel mt-10">
                  <div className="m-panel__body p10">
                    <div className="row">
                      <div className="col-md-2">
                        <div className='form-group select_h150'>
                          <label htmlFor='exampleInput'>Select zone</label>
                          <Select className="form-control"
                            showSearch
                            mode="multiple"
                            placeholder="-- Please Select --"
                            onChange={(value) => {
                              setSearchedItem({...searchedItem,zone_id:value})
                            }}
                            value={searchedItem.zone_id}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >{
                              vendorList?.ZoneList.map((item =>
                                <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                              ))
                            }
                          </Select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className='form-group select_h150'>
                          <label htmlFor='exampleInput'>Select state</label>
                          <div className="">
                            <Select className="form-control"
                              showSearch
                              mode="multiple"
                              onChange={(value) => {
                                setSearchedItem({...searchedItem,state_id:value})
                              }}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              value={searchedItem.state_id}
                            >{
                                vendorList?.StateList.map((item =>
                                  <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                                ))
                              }
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className='form-group select_h150'>
                          <label htmlFor='exampleInput'>Select type of services</label>
                          <Select className="form-control"
                            showSearch
                            mode="multiple"
                            onChange={(value) => {
                              setSearchedItem({...searchedItem,type_of_service_ids:value})
                            }}
                            placeholder="-- Please Select --"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={searchedItem.serviceType}
                          >{
                              vendorList?.ServiceList.map((item =>
                                <Option key={item.id} value={item.id}>{item.name}</Option>
                              ))
                            }
                          </Select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className='form-group'>
                          <label htmlFor='exampleInput'>Vendor Name</label>
                          <Select className="form-control"
                            allowClear={true}
                            showSearch
                            onChange={(value) => {
                              setSearchedItem({...searchedItem,id:value})
                            }}
                            placeholder="-- Please Select --"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={searchedItem.id}
                          >{
                              vendorList?.VendorNameList.map(((item,index) =>
                                <Option key={index} value={item.id}>{item.vendor_name}</Option>
                              ))
                            }
                          
                          </Select>
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className='form-group'>
                          <label htmlFor='exampleInput'>Store Name</label>
                          <Select className="form-control"
                            showSearch
                            allowClear={true}
                            onChange={(value) => {
                              setSearchedItem({...searchedItem,store_id:value})
                            }}
                            placeholder="-- Please Select --"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={searchedItem.storeName}
                          >{
                              vendorList?.StoreList.map(((item,index) =>
                                <Option key={index} value={item.store_id}>{item.store_name}</Option>
                              ))
                            }
                          </Select>
                        </div>
                      </div>

                      <div className="col-md-1 btn-no-lbl">
                        <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={handleSearch}>
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-panel">
                  <div className="m-panel__body p10">
                    <div className="m-table__main">
                      <div className="m-table__responsive">
                        <Table columns={TableColumns} dataSource={tableData} className="vendor_table"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          )}
        </div>

      </div> : null}
      {
        status?.isVendorEdit ? <VendorEdit /> : null
      }
      {
        status?.isVendorCreate ?
          <VendorAdd /> : null
      }
      <Footer />
    </>
  )
}

export default Vendors;
